import classNames from 'classnames'
import { Typography } from '@/components/Typography'
import { ChevronLeft, ChevronRight } from 'react-feather'
import { AchieveLink } from 'components/AchieveLink'
import { mainProductConfig } from 'constants/mainProductConfig'
import { cleanDomain } from 'utils/cleanDomain'
import { useEffect, useState, useMemo } from 'react'
import { withUuid } from 'utils/shared'

export default function BillsHeaderNav({
  mainNavigation,
  activeSubMenuIndex,
  handleMainItemClick,
  handleBackToMain,
  handleCloseMenu,
  siteEnv,
}) {
  const [domain, setDomain] = useState('')
  const subNavList = useMemo(
    () => withUuid(mainNavigation?.filter((item) => item.subNavMenus) ?? []),
    [mainNavigation]
  )
  const mainNavList = useMemo(
    () => withUuid(mainNavigation?.filter((item) => !item.subNavMenus) ?? []),
    [mainNavigation]
  )

  const MenuLink = ({ url, label, index, mainNavLabel, title, children, key }) => {
    return (
      <AchieveLink
        href={url}
        key={key}
        withNextLink
        track={{
          list_name: 'Header Nav Link Click',
          mega_menu_tab: mainNavLabel,
          mega_menu_column: title,
          mega_menu_link: label,
          click_id: label,
          click_position: index + 1,
          click_text: `${
            mainProductConfig[siteEnv || 'achieve']?.['MainProductHyphen']
          } | ${label}`,
          nav_link_section: 'Mega Menu',
          track_event: 'mega_menu',
          event_action: 'link_click',
          event_type: 'link_click',
        }}
        className="no-underline"
        onClick={() => {
          handleCloseMenu()
        }}
      >
        {children}
      </AchieveLink>
    )
  }

  useEffect(() => {
    if (window) {
      setDomain(cleanDomain(window.location.href))
    }
  }, [])

  return (
    <div id="bills-header-nav" className="flex overflow-hidden mt-4">
      <ul
        className={classNames(
          'flex flex-col min-w-full list-none p-0 m-0 transition-transform duration-300 ease-in-out transform',
          {
            '-translate-x-80': activeSubMenuIndex,
          }
        )}
      >
        {subNavList.map((item) => (
          <li
            key={item.uuid}
            className="flex flex-col gap-2 text-white font-normal px-4 py-3 shadow-[inset_0_-1px_0_rgba(0,0,0,0.25)] cursor-pointer hover:bg-[#1f5588]"
          >
            <div
              onClick={() => handleMainItemClick(item)}
              className="flex flex-row gap-2 justify-between"
            >
              <Typography component="div">{item.label}</Typography>
              <ChevronRight />
            </div>
          </li>
        ))}
        <li className="flex flex-col gap-2 text-white font-bold px-4 py-3 mt-2">
          More from Bills.com
        </li>
        {mainNavList.map((item, index) => (
          <li
            key={item.uuid}
            className="flex flex-col gap-2 text-white font-normal px-4 py-3 shadow-[inset_0_-1px_0_rgba(0,0,0,0.25)] cursor-pointer hover:bg-[#1f5588]"
          >
            <MenuLink
              url={`${domain}${item.url}`}
              label={item.label}
              index={index}
              mainNavLabel={item.label}
              title={item.label}
            >
              <div className="flex flex-row gap-2 justify-between no-underline!">
                <Typography className="text-white">{item.label}</Typography>
              </div>
            </MenuLink>
          </li>
        ))}
      </ul>
      <ul
        className={classNames(
          'flex flex-col min-w-full list-none p-0 m-0 transition-transform duration-300 ease-in-out transform',
          {
            '-translate-x-80': activeSubMenuIndex,
          }
        )}
      >
        <li
          className="flex gap-2 text-white font-bold px-4 py-3 shadow-[inset_0_-1px_0_rgba(0,0,0,0.25)] cursor-pointer pl-10 bg-[#1f5588] hover:bg-[#1f5588]"
          onClick={handleBackToMain}
        >
          <div className="absolute left-2">
            <ChevronLeft />
          </div>
          Back to Main Menu
        </li>
        {activeSubMenuIndex?.subNavMenus?.[0]?.menuItems?.map((subItem, subIndex) => (
          <MenuLink
            key={subIndex}
            url={`${domain}${subItem.url}`}
            label={subItem.label}
            index={subIndex}
            mainNavLabel={subItem.label}
            title={activeSubMenuIndex.label}
          >
            <li className="flex gap-2 text-white font-normal px-4 py-3 shadow-[inset_0_-1px_0_rgba(0,0,0,0.25)] cursor-pointer pl-10 bg-[#1f5588] hover:bg-[#2c5e8e]">
              <Typography className="text-white">{subItem.label}</Typography>
            </li>
          </MenuLink>
        ))}
      </ul>
    </div>
  )
}
